import { computed, reactive, ref } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { SharedPageProps } from '@/Types/inertia';
import { useThemeStore } from '@/Stores/Theme';
import appConfig from './../Config/default';
import { Permissions } from '@/Types/Models/user';

import loginLogoDark from './../../assets/images/brand/logo-full-dark.svg';
import loginLogoLight from './../../assets/images/brand/logo-full-light.svg';
import loginLogoDarkIcon from './../../assets/images/brand/logo-icon-dark.svg';
import loginLogoLightIcon from './../../assets/images/brand/logo-icon-light.svg';

export function useAuth() {
	const page = usePage<SharedPageProps>();
    const RoleSuperadmin = 'superadmin';
    const RoleAdmin = 'admin';
    const RoleCustomer = 'customer';
    const auth = ref(page.props.auth);
    const currentRoles = ref(page.props.auth?.user?.roles ?? []);
    const themeStore = useThemeStore();
    const authRoles = computed(() => {
        let temp = [];
        for(let item of currentRoles.value){
            temp.push(item.name);
        }
        return temp;
    });

    const isLoggedIn = computed(() => {
        return page.props.auth?.isLoggedIn ?? false;
    });

    const isSuperadmin = computed(() => {
        return authRoles.value.includes(RoleSuperadmin);
    });

    const isAdmin = computed(() => {
        return authRoles.value.includes(RoleAdmin);
    });

    const isCustomer = computed(() => {
        return authRoles.value.includes(RoleCustomer);
    });

    const logo  = computed(() : {
        full: string,
        icon: string,
    } => {
        let output = {
            full: '',
            icon: '',
        };
        let companyLogoFull = page.props.brand?.company_logo_url ?? '';
        let companyLogoDarkFull = page.props.brand?.company_logo_dark_url ?? companyLogoFull;
        let companyLogoIcon = page.props.brand?.company_logo_icon_url ?? '';
        let companyLogoDarkIcon = page.props.brand?.company_logo_icon_dark_url ?? companyLogoIcon;
        if(themeStore.isDark){
            output.full = loginLogoDark;
            output.icon = loginLogoDarkIcon;
            if(companyLogoDarkFull){
                output.full = companyLogoDarkFull;
            }
            if(companyLogoDarkIcon){
                output.icon = companyLogoDarkIcon;
            }
        }
        else{
            output.full = loginLogoLight;
            output.icon = loginLogoLightIcon;
            if(companyLogoFull){
                output.full = companyLogoFull;
            }
            if(companyLogoIcon){
                output.icon = companyLogoIcon;
            }
        }
        return output;
    });

    const brandName = 'EasyInvoice';

    const permissions = reactive<Permissions>(page.props.auth?.access ?? {});

    return {
        auth,
        authRoles,
        isSuperadmin,
        isAdmin,
        isCustomer,
        logo,
        brandName,
        permissions,
        isLoggedIn,
    }
}
